module.exports = __webpack_public_path__ + "img/Detail-l.ed671516.png";